import Select from "react-select";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useRef, useState } from "react";
import { ICausaBasica } from "../../entities/ICausaBasica";
import { ICausaSistema } from "../../entities/ICausaSistema";
import { IDesviacion, IReporteACCausasBasicas, IReporteACCausasInmediatas, IReporteACCausasSistema } from "../../entities/IDesviacion";
import IGerencia from "../../entities/IGerencia";
import IVicePresidencia from "../../entities/IVicePresidencia";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { getAPI, getAPIBatch } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserToken } from "../../helpers/userHelper";
import { API_ADMIN_GERENCIA, API_VPP, ROW_COUNT, URL_SUPPORT } from "../../helpers/variableHelper";
import DesviacionService from "../../services/DesviacionService";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import { cParams, cParamsActiveOrderTitle } from "../../helpers/paramsHelper";
import Loading from "../../cross/Loading";
import { ICausaInmediata } from "../../entities/ICausaInmediata";
import RenderValue from "../../controls/RenderValue";
import RenderTitle from "../../controls/RenderTitle";
const MySwal = withReactContent(Swal);

interface IReporteAnalisisCausalProps {
  items?: Array<ICausaInmediata>;
  itemsBasica?: Array<ICausaBasica>;
  itemsSistema?: Array<ICausaSistema>;
  busqueda?: boolean;
  cbViceprecidencia?: Array<IVicePresidencia>;
  cbGerenciaSubgerencia?: Array<IGerencia>;
  is_test?: boolean;
}

export default function ReporteAnalisisCausal({
  is_test,
  items,
  busqueda,
  itemsBasica,
  itemsSistema,
  cbViceprecidencia,
  cbGerenciaSubgerencia,
}: IReporteAnalisisCausalProps) {
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const columnHelperCS = createColumnHelper<IReporteACCausasSistema>();
  const columnHelperCB = createColumnHelper<IReporteACCausasBasicas>();
  const columnHelperCI = createColumnHelper<IReporteACCausasInmediatas>();
  const [listCausasInmediatas, setListCausasInmediatas] = useState<Array<ICausaInmediata>>(items || []);
  const [listCausasBasicas, setListCausasBasicas] = useState<Array<ICausaBasica>>(itemsBasica || []);
  const [listCausasSistema, setListCausasSistema] = useState<Array<ICausaSistema>>(itemsSistema || []);

  const [pageSizeCB, setPageSizeCB] = useState(ROW_COUNT);
  const [pageSizeCI, setPageSizeCI] = useState(ROW_COUNT);
  const [pageSizeCS, setPageSizeCS] = useState(ROW_COUNT);

  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>(cbViceprecidencia || []);
  const [comboGSG, setComboGSG] = useState<Array<IGerencia>>(cbGerenciaSubgerencia || []);

  const [vpp, setVpp] = useState<IComboboxOption | null>(null);
  const [gsg, setGsg] = useState<IComboboxOption | null>(null);
  const refNroDesviacion = React.createRef<HTMLInputElement>();
  const refFechaDeteccionDesde = React.createRef<HTMLInputElement>();
  const refFechaDeteccionHasta = React.createRef<HTMLInputElement>();
  const totalPageListCausasI = useRef<number>(0);
  const totalPageListCausasB = useRef<number>(0);
  const totalPageListCausasS = useRef<number>(0);

  const [busquedaInicial, setBusquedaInicial] = useState(busqueda ?? false);
  const [isDownloading, setIsDownloading] = useState(false);
  enum ETipoCausa {
    Inmediata = 1,
    Basica = 2,
    Sistema = 3,
  }
  console.log(isLoading);
  console.log(pageSizeCB);
  console.log(pageSizeCI);
  console.log(pageSizeCS);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any, type?: any) => {
    return <RenderValue value={value} type={type} />;
  };

  const componentAcciones = (value: any) => {
    console.log("value", value);
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          window.open(`/agregardesviacion?id=${value.row.original.CORRELATIVO.split("-")[1]}`, "_blank");
        }}></i>
    );
  };

  usePromiseEffect(async () => {
    setIsLoading(true);
    await fillCombos();
    let token = await cognitoUserToken();
    setToken(token);
  }, []);

  const fillCombos = async () => {
    let urls = [`${URL_SUPPORT}${API_VPP}/getall`];
    let results = is_test ? [{ data: { data: [] } }] : await getAPIBatch(urls, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle);

    results.forEach((result, index) => {
      if (index == 0) {
        setComboVcc(result.data.data);
      }
    });
  };

  const fillComboGSG = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      VICEPRESIDENCIA: vppId,
    };
    const comboGSG = (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboGSG(comboGSG);
  };

  const getColumns = (tipo: ETipoCausa) => {
    if (tipo === ETipoCausa.Inmediata) {
      return [
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.CORRELATIVO, {
          id: "CORRELATIVO_COLUMNA",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Correlativo"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.ASUNTO, {
          id: "ASUNTO",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Asunto"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.CAUSA, {
          id: "CAUSA",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Causa"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row) => row.TIPO_CAUSA_INMEDIATA, {
          id: "TIPO_CAUSA",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Tipo Causa"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row) => row.ACTO_CONDICION_SUBESTANDAR, {
          id: "ACTO_CONDICION_SUBESTANDAR",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Acto Condición Subestandar"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row) => row.ESTADO, {
          id: "ESTADO",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Estado"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.UNIDAD_PROYECTO, {
          id: "UNIDAD_PROYECTO",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Unidad Proyecto"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.GERENCIA_SUBGERENCIA, {
          id: "GERENCIA_SUBGERENCIA_COLUMNA",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Gerencia/Subgerencia"),
          tipo: ITipo_Campo.text,
        } as any),

        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.ACCION, {
          id: "ACCION",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Acción"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.RESPONSABLE_DISPLAY, {
          id: "RESPONSABLE",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Responsable"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.FECHA_HASTA, {
          id: "FECHA_HASTA",
          cell: (info: CellContext<IReporteACCausasInmediatas, Date>) =>
            componentValue(info.getValue(), moment(info.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text),
          header: () => component("Fecha Hasta"),
          tipo: ITipo_Campo.date,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.FECHA_ACCION_REALIZADA, {
          id: "FECHA_ACCION_REALIZADA",
          cell: (info: CellContext<IReporteACCausasInmediatas, Date>) =>
            componentValue(info.getValue(), moment(info.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text),
          header: () => component("Fecha acción realizada"),
          tipo: ITipo_Campo.date,
        } as any),
        columnHelperCI.accessor((row) => row.ID, {
          id: "ACCIONES",
          _cell: (info: CellContext<IReporteACCausasInmediatas | ICausaBasica | ICausaSistema, string>) => componentAcciones(info),
          get cell() {
            return this._cell;
          },
          set cell(value) {
            this._cell = value;
          },
          header: () => component("Acciones"),
          tipo: ITipo_Campo.text,
          disableSorting: true,
        } as any),
      ] as any;
    } else if (tipo === ETipoCausa.Basica) {
      return [
        columnHelperCB.accessor((row: IReporteACCausasBasicas) => row.CORRELATIVO, {
          id: "CORRELATIVO_COLUMNA",
          cell: (info: CellContext<IReporteACCausasBasicas, string>) => componentValue(info.getValue()),
          header: () => component("Correlativo"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCB.accessor((row: IReporteACCausasBasicas) => row.ASUNTO, {
          id: "ASUNTO",
          cell: (info: CellContext<IReporteACCausasBasicas, string>) => componentValue(info.getValue()),
          header: () => component("Asunto"),
          tipo: ITipo_Campo.text,
        } as any),

        columnHelperCB.accessor((row: IReporteACCausasBasicas) => row.ESTADO, {
          id: "ESTADO",
          cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
          header: () => component("Estado"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCB.accessor((row: IReporteACCausasBasicas) => row.UNIDAD_PROYECTO, {
          id: "UNIDAD_PROYECTO",
          cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
          header: () => component("Unidad Proyecto"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCB.accessor((row: IReporteACCausasBasicas) => row.GERENCIA_SUBGERENCIA, {
          id: "GERENCIA_SUBGERENCIA_COLUMNA",
          cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
          header: () => component("Gerencia/Subgerencia"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCB.accessor((row: IReporteACCausasBasicas) => row.CAUSA, {
          id: "CAUSA",
          cell: (info: CellContext<IReporteACCausasBasicas, string>) => componentValue(info.getValue()),
          header: () => component("Causa"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCB.accessor((row) => row.TIPO_CAUSA_BASICA, {
          id: "TIPO_CAUSA",
          cell: (info: CellContext<IReporteACCausasBasicas, string>) => componentValue(info.getValue()),
          header: () => component("Tipo Causa"),
          tipo: ITipo_Campo.text,
        } as any),

        columnHelperCB.accessor((row: IReporteACCausasBasicas) => row.ACCION, {
          id: "ACCION",
          cell: (info: CellContext<IReporteACCausasInmediatas, string>) => componentValue(info.getValue()),
          header: () => component("Acción"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCB.accessor((row) => row.RESPONSABLE_DISPLAY, {
          id: "RESPONSABLE",
          cell: (info: CellContext<IReporteACCausasBasicas, string>) => componentValue(info.getValue()),
          header: () => component("Responsable"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.FECHA_HASTA, {
          id: "FECHA_HASTA",
          cell: (info: CellContext<IReporteACCausasInmediatas, Date>) =>
            componentValue(info.getValue(), moment(info.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text),
          header: () => component("Fecha Hasta"),
          tipo: ITipo_Campo.date,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.FECHA_ACCION_REALIZADA, {
          id: "FECHA_ACCION_REALIZADA",
          cell: (info: CellContext<IReporteACCausasInmediatas, Date>) =>
            componentValue(info.getValue(), moment(info.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text),
          header: () => component("Fecha acción realizada"),
          tipo: ITipo_Campo.date,
        } as any),
        columnHelperCB.accessor((row) => row.ID, {
          id: "VER",
          _cell: (info: CellContext<IReporteACCausasBasicas | ICausaBasica | ICausaSistema, string>) => componentAcciones(info),
          get cell() {
            return this._cell;
          },
          set cell(value) {
            this._cell = value;
          },
          header: () => component("Acciones"),
          tipo: ITipo_Campo.text,
          disableSorting: true,
        } as any),
      ] as any;
    } else {
      return [
        columnHelperCS.accessor((row: IReporteACCausasSistema) => row.CORRELATIVO, {
          id: "CORRELATIVO_COLUMNA",
          cell: (info: CellContext<IReporteACCausasSistema, string>) => componentValue(info.getValue()),
          header: () => component("Correlativo"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row: IReporteACCausasSistema) => row.ASUNTO, {
          id: "ASUNTO",
          cell: (info: CellContext<IReporteACCausasSistema, string>) => componentValue(info.getValue()),
          header: () => component("Asunto"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row: IReporteACCausasSistema) => row.CAUSA, {
          id: "CAUSA",
          cell: (info: CellContext<IReporteACCausasSistema, string>) => componentValue(info.getValue()),
          header: () => component("Causa"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row: IReporteACCausasSistema) => row.TIPO_REQUISITO_SISTEMA, {
          id: "TIPO_REQUISITO_SISTEMA",
          cell: (info: CellContext<IReporteACCausasSistema, string>) => componentValue(info.getValue()),
          header: () => component("Tipo Ámbito de Gestión"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row) => row.DESCRIPCION_REQUISITO, {
          id: "DESCRIPCION_REQUISITO",
          cell: (info: CellContext<IReporteACCausasSistema, string>) => componentValue(info.getValue()),
          header: () => component("Descripción del Ámbito de Gestión"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row: IReporteACCausasSistema) => row.ESTADO, {
          id: "ESTADO",
          cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
          header: () => component("Estado"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row: IReporteACCausasSistema) => row.UNIDAD_PROYECTO, {
          id: "UNIDAD_PROYECTO",
          cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
          header: () => component("Unidad Proyecto"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row: IReporteACCausasSistema) => row.GERENCIA_SUBGERENCIA, {
          id: "GERENCIA_SUBGERENCIA_COLUMNA",
          cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
          header: () => component("Gerencia/Subgerencia"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row) => row.ACCION, {
          id: "ACCION",
          cell: (info: CellContext<IReporteACCausasSistema, string>) => componentValue(info.getValue()),
          header: () => component("Acciones"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCS.accessor((row) => row.RESPONSABLE_DISPLAY, {
          id: "RESPONSABLE",
          cell: (info: CellContext<IReporteACCausasSistema, string>) => componentValue(info.getValue()),
          header: () => component("Responsable"),
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.FECHA_HASTA, {
          id: "FECHA_HASTA",
          cell: (info: CellContext<IReporteACCausasInmediatas, Date>) =>
            componentValue(info.getValue(), moment(info.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text),
          header: () => component("Fecha Hasta"),
          tipo: ITipo_Campo.date,
        } as any),
        columnHelperCI.accessor((row: IReporteACCausasInmediatas) => row.FECHA_ACCION_REALIZADA, {
          id: "FECHA_ACCION_REALIZADA",
          cell: (info: CellContext<IReporteACCausasInmediatas, Date>) =>
            componentValue(info.getValue(), moment(info.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text),
          header: () => component("Fecha acción realizada"),
          tipo: ITipo_Campo.date,
        } as any),
        columnHelperCS.accessor((row) => row.ID, {
          id: "VER",
          _cell: (info: CellContext<IReporteACCausasSistema | ICausaBasica | ICausaSistema, string>) => componentAcciones(info),
          get cell() {
            return this._cell;
          },
          set cell(value) {
            this._cell = value;
          },
          header: () => component("Acciones"),
          tipo: ITipo_Campo.text,
          disableSorting: true,
        } as any),
      ] as any;
    }
  };

  const handleValidacionBusqueda = () => {
    if (
      (moment(refFechaDeteccionDesde.current?.value).isValid() && !moment(refFechaDeteccionHasta.current?.value).isValid()) ||
      (!moment(refFechaDeteccionDesde.current?.value).isValid() && moment(refFechaDeteccionHasta.current?.value).isValid())
    ) {
      MySwal.fire({
        html: (
          <div>
            <h3>Debe ingresar ambas fechas</h3>
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });
      return false;
    }

    if (moment(refFechaDeteccionDesde.current?.value) > moment(refFechaDeteccionHasta.current?.value)) {
      MySwal.fire({
        html: (
          <div>
            <h3>Fecha detección desde no puede ser superior a fecha hasta</h3>
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });
      return false;
    }
    return true;
  };
  const handleBuscar = () => {
    if (handleValidacionBusqueda()) {
      let paramsBusqueda = {
        CORRELATIVO: refNroDesviacion.current?.value,
        FECHA_DETECCION_DESDE: refFechaDeteccionDesde.current?.value ? new Date(refFechaDeteccionDesde.current?.value) : null,
        FECHA_DETECCION_HASTA: refFechaDeteccionHasta.current?.value ? new Date(refFechaDeteccionHasta.current?.value) : null,
        VICEPRESIDENCIA: vpp?.value,
        GERENCIA_SUBGERENCIA: gsg?.value,
      };
      setBusquedaInicial(true);
      return paramsBusqueda;
    }
    return null;
  };

  const handleBuscarCI = async (pagination?: IPagination) => {
    let paramsBusqueda = handleBuscar();
    let defaultParams = pagination || cParams;
    let resultI = await DesviacionService.getReporteAnalisisCausalCI(token, {
      ...defaultParams,
      ORDENADOPOR: `CI."ID_DESVIACION"`,
      ...paramsBusqueda,
    });
    setListCausasInmediatas(resultI.data);
    totalPageListCausasI.current = resultI.pages;
  };
  const handleBuscarCB = async (pagination?: IPagination) => {
    let paramsBusqueda = handleBuscar();
    let defaultParams = pagination || cParams;
    let resultB = await DesviacionService.getReporteAnalisisCausalCB(token, {
      ...defaultParams,
      ORDENADOPOR: `CB."ID_DESVIACION"`,
      ...paramsBusqueda,
    });
    setListCausasBasicas(resultB.data);
    totalPageListCausasB.current = resultB.pages;
  };
  const handleBuscarCS = async (pagination?: IPagination) => {
    let paramsBusqueda = handleBuscar();

    let defaultParams = pagination || cParams;
    let resultS = await DesviacionService.getReporteAnalisisCausalCS(token, {
      ...defaultParams,
      ORDENADOPOR: `CS."ID_DESVIACION"`,
      ...paramsBusqueda,
    });
    setListCausasSistema(resultS.data);
    totalPageListCausasS.current = resultS.pages;
  };

  const handleLimpiarCampos = () => {
    (refNroDesviacion.current as HTMLInputElement).value = "";
    (refFechaDeteccionDesde.current as HTMLInputElement).value = "";
    (refFechaDeteccionHasta.current as HTMLInputElement).value = "";
    setVpp(null);
    setGsg(null);
    setComboGSG([]);
  };

  const handleExportExcel = async () => {
    let paramsBusqueda = {
      CORRELATIVO: refNroDesviacion.current?.value,
      FECHA_DETECCION_DESDE: refFechaDeteccionDesde.current?.value ? new Date(refFechaDeteccionDesde.current?.value) : null,
      FECHA_DETECCION_HASTA: refFechaDeteccionHasta.current?.value ? new Date(refFechaDeteccionHasta.current?.value) : null,
      VICEPRESIDENCIA: vpp?.value?.toString(),
      GERENCIA_SUBGERENCIA: gsg?.value?.toString(),
    };
    if (handleValidacionBusqueda()) {
      setIsDownloading(true);
      await DesviacionService.getExcelReporteAC(token, {
        searchCausasBasicas: {
          ...cParams,
          ORDENADOPOR: `CB."ID_DESVIACION"`,
          ...paramsBusqueda,
        },
        searchCausasInmediatas: {
          ...cParams,
          ORDENADOPOR: `CI."ID_DESVIACION"`,
          ...paramsBusqueda,
        },
        searchCausasSistema: {
          ...cParams,
          ORDENADOPOR: `CS."ID_DESVIACION"`,
          ...paramsBusqueda,
        },
      });
      setIsDownloading(false);
    }
  };

  return (
    <div>
      {isDownloading && <Loading key="loadingDownload" cssContainer="loadingFlotante" />}
      <div className="row">
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit">Reporte de Analisis Causal</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Nota:</strong> Este reporte permite consultar las Causas en un período de tiempo determinado.
                </small>
              </div>
              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Número de Desviación (ejemplo 350;351):</label>
                    <input className="form-control form-control-sm" type="text" placeholder="Indique el número" ref={refNroDesviacion} />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0"></div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Vicepresidencia:</label>
                    <Select
                      options={
                        comboVcc.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={vpp || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setVpp(e || "");
                        fillComboGSG(e.label || "");
                      }}
                    />
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Gerencia/Subgerencia:</label>
                    <Select
                      options={
                        comboGSG.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={gsg || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setGsg(e || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Fecha detección (desde - hasta)</label>
                    <div className="d-flex">
                      <input className="form-control form-control-sm w-50 me-2" type="date" placeholder="Desde" ref={refFechaDeteccionDesde} />
                      <input className="form-control form-control-sm w-50" type="date" placeholder="Hasta" ref={refFechaDeteccionHasta} />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        let flag = handleBuscar();
                        if (flag != null) {
                          handleBuscarCI();
                          handleBuscarCB();
                          handleBuscarCS();
                        }
                      }}>
                      {" "}
                      <i className="bi bi-search me-2"></i> Buscar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={() => {
                        handleLimpiarCampos();
                      }}>
                      {" "}
                      <i className="bi bi-trash me-2"></i>Limpiar Campos
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success me-2"
                      onClick={() => {
                        handleExportExcel();
                      }}>
                      <i className="bi bi-file-earmark-excel"></i> Exportar Excel
                    </button>
                  </div>
                </div>
              </div>

              <div className="" id="collapseGeneradas">
                <div className="card card-body border-0 p-0 mt-2">
                  <div className="row">
                    <div className="col-12">
                      <div className="container-fluid mb-4">
                        <h1 className="titPrincipal colorTit mt-2"></h1>
                        {busquedaInicial && (
                          <div className="row">
                            <div className="col-12">
                              <h1 className="titPrincipal colorTit mt-2">Causas Inmediatas</h1>
                              <AdminListaPagination
                                defaultSortBy="ID"
                                sortDirection="DESC"
                                totalPages={totalPageListCausasI}
                                resultPerPage={ROW_COUNT}
                                callback={(pagination) => {
                                  handleBuscarCI(pagination);
                                }}
                                data={listCausasInmediatas || []}
                                reload={() => {
                                  handleBuscarCI();
                                }}
                                columnsDef={getColumns(ETipoCausa.Inmediata)}
                                hideAdd={true}
                                hideExport={true}
                                callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                  setPageSizeCI(pageSize);
                                  let pagination = filters as IPagination;
                                  pagination.PAGINA = 1;
                                  pagination.PAGINADO = pageSize;
                                  pagination.ORDENADOPOR = `CI."ID_DESVIACION"`;
                                  pagination.ORIENTACION = "DESC";
                                  handleBuscarCI(pagination);
                                }}
                              />
                            </div>
                            <div className="col-12">
                              <h1 className="titPrincipal colorTit mt-2">Causas Básicas</h1>
                              <AdminListaPagination
                                defaultSortBy="ID"
                                sortDirection="DESC"
                                totalPages={totalPageListCausasB}
                                resultPerPage={ROW_COUNT}
                                callback={(pagination) => {
                                  handleBuscarCB(pagination);
                                }}
                                data={listCausasBasicas || []}
                                reload={() => {
                                  handleBuscarCB();
                                }}
                                columnsDef={getColumns(ETipoCausa.Basica)}
                                hideAdd={true}
                                hideExport={true}
                                callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                  setPageSizeCB(pageSize);
                                  let pagination = filters as IPagination;
                                  pagination.PAGINA = 1;
                                  pagination.PAGINADO = pageSize;
                                  pagination.ORDENADOPOR = `CB."ID_DESVIACION"`;
                                  pagination.ORIENTACION = "DESC";
                                  handleBuscarCB(pagination);
                                }}
                              />
                            </div>
                            <div className="col-12">
                              <h1 className="titPrincipal colorTit mt-2">Ámbitos de Gestión</h1>
                              <AdminListaPagination
                                defaultSortBy="ID"
                                sortDirection="DESC"
                                totalPages={totalPageListCausasS}
                                resultPerPage={ROW_COUNT}
                                callback={(pagination) => {
                                  handleBuscarCS(pagination);
                                }}
                                data={listCausasSistema || []}
                                reload={() => {
                                  handleBuscarCS();
                                }}
                                columnsDef={getColumns(ETipoCausa.Sistema)}
                                hideAdd={true}
                                hideExport={true}
                                callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                  setPageSizeCS(pageSize);
                                  let pagination = filters as IPagination;
                                  pagination.PAGINA = 1;
                                  pagination.PAGINADO = pageSize;
                                  pagination.ORDENADOPOR = `CS."ID_DESVIACION"`;
                                  pagination.ORIENTACION = "DESC";
                                  handleBuscarCS(pagination);
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
